import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import TABS from './tabs';
import { TabSelectorWrapper, TabButton } from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/TabSelector/styled';
import { selectVulnDetailSelectedTab } from 'store/ManageGeneral/selectors';
import { setVulnerabilityDetailTab } from 'store/ManageGeneral/actions';
import useTabsShortcuts from 'Hooks/useTabsShortcuts';

// Community's backend has no route to list comments for a single vulnerability (Comment
// is a plain ReadWriteWorkspacedView with no /vulnerability/<id> sub-route and no
// filterset_class), so the whole tab -- new in this migration -- can never load anything.
// Hide it here rather than relying on FEATURE_COMMENTS, which is a false positive: that
// permission is allowed in community but doesn't mean this specific backend capability
// exists.
const enabledTabs = TABS.filter((tab) => tab.id !== 'comment');

const Tabs = ({ scope }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const selectedTab = useSelector(selectVulnDetailSelectedTab);

  const getLabel = (tab) => intl.formatMessage({ id: tab.intlId });
  const isActive = (tab) => tab.id === selectedTab.id;

  useTabsShortcuts({
    tabs: enabledTabs,
    activeId: selectedTab.id,
    onChange: (id) => dispatch(setVulnerabilityDetailTab(id)),
    scope
  });

  return (
    <TabSelectorWrapper>
      { enabledTabs.map((tab) => (
        <TabButton
          active={ isActive(tab) }
          key={ tab.id }
          onClick={ () => dispatch(setVulnerabilityDetailTab(tab.id)) }
          children={ getLabel(tab) }
        />
      ))}
    </TabSelectorWrapper>
  );
};

export default Tabs;
